<template>
    <div class="table-container">
        <table id="offer_table" class="table responsive-table"  @click="goToManageOffers($event)">
            <thead v-if="contractOffers.length > 0">
                <tr>
                    <th v-for="(item,key) in tableTitles" :key="key">
                        {{item.title}}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="shadow-none border-0 px-3 w-100" v-if="getPrices.length < 1">
                    <td colspan="11" class="px-0">
                        <div class="alert alert-secondary mt-3 text-center">
                            <i class="fas fa-info-circle mr-2"></i>
                            Offers will not be displayed to buyers until Settlement Prices have been updated. Click on {{ settlementPricesButtonText }} to update Settlement Prices
                        </div>
                    </td>     
                </tr> 
                <tr class="shadow-none w-100" v-else-if="contractOffers.length < 1">
                    <td class="px-0" colspan="13">
                        <div class="alert alert-secondary mt-3 text-center">
                            <i class="fas fa-info-circle mr-2"></i>
                            You have not created any offers for this market
                        </div>
                    </td>
                </tr>
                <tr v-for="(offer,key) in contractOffers" :key="key" class="offer-rows">
                    <td>{{offer.contract.buyer.name}}</td>
                    <td>
                        <span v-if="offer.storage_type_id == 'SPOT'">{{offer.fuel_id | fueltype}}</span>
                        <span v-else>Network</span>
                    </td>
                    <td>
                        <span v-if="offer.storage_type_id == 'SPOT'">{{offer.terminal_id |terminalsname}}</span>
                        <span v-else>{{ networks.find(n => n._id === offer.networkId).name }}</span>
                    </td>
                    
                    <!-- currentMonthMaximumAvailable -->
                    <td v-if="offer.contract.frequency_quantity && offer.contract.frequency_quantity.length > 0">{{ offer.contract.frequency_quantity | currentMonthMaximumAvailable }}</td>
                    <td v-else>{{offer.maximumAvailable | volumeformat}}</td>
                    <!-- currentMonthTotal -->
                    <td v-if="offer.contract && offer.contract.frequency_quantity">{{offer.contract.frequency_quantity | currentMonthTotal}}</td>
                    <td v-else>N/A</td>

                    <td>{{offer.fuel_id | offerbiopricing}}</td>
                    <td>{{offer.type_id | offertype}}</td>
                    <td>
                        <span v-if="offer.storage_type_id == 'SPOT'">{{offer | liftingperiodformat}}</span>
                        <span v-else>N/A</span>
                    </td>
                    <td>
                        <span v-if="offer.contract.buyer.credit">{{offer.contract.buyer.credit.days | creditdaysformat}}</span>
                        <span v-else>N/A</span>
                    </td>
                    <td>
                        <span v-if="offer.type_id == 'FIXED'">&mdash;</span>
                        <span v-else-if="$store.getters['login/isPricingEngineEnabled']">{{ offer.premium | priceformat }}</span>
                        <span v-else>{{offer.price | priceformat}}</span>
                    </td>
                    <td>
                        <span v-if="offer.type_id == 'FIXED' || $store.getters['login/isPricingEngineEnabled']">{{offer.price | priceformat}}</span>
                        <span v-else>{{offer.livePrice | priceformat}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { _checkOffersAvailabilitySetting } from '@/util/offers.js';
import { hasContractRemainingQuantity, _isDateWithinContractAvailability } from '@/util/contracts.js';

export default {
    data(){
        return {
            tableTitles:[
                {title: 'Buyer', sortKey: 'buyer'},
                {title: 'Product', sortKey: 'fuel'},
                {title: 'Terminal', sortKey: 'terminal'},
                {title: 'Vol Remaining/L', sortKey: 'volume_remaining'},
                {title: 'Current Month Vol/L', sortKey: 'current_month_total'},
                {title: 'Bio Pricing', sortKey: 'bio_pricing'},
                {title: 'Pricing Method', sortKey: 'pricing_method'},
                {title: 'Lifting Period', sortKey: 'collection_days'},
                {title: 'Payment Terms', sortKey: 'credit_days'},
                {title: 'Premium (ppl)', sortKey: 'premium'},
                {title: 'Price (ppl)', sortKey: 'price'}
            ]
        }
    },
    computed: {
        ...mapState('sellerOffers', ['offersAvailability']),
        ...mapGetters('sellerOffers', ['liveOffersSeller']),
        ...mapGetters('livePrices',['getPrices', 'settlementPricesButtonText']),   
        ...mapGetters('metadata', ['networks']),     
        contractOffers: {
            get: function(){
                let offers = []

                if (this.liveOffersSeller && this.getPrices.length > 0 &&
                    this.offersAvailability && _checkOffersAvailabilitySetting("CONTRACTS")){
                    offers = this.liveOffersSeller.filter(offer => 
                        offer.isContract 
                        && offer.status_type_id === "ACTIVE" // Ensure contract is active
                        && _isDateWithinContractAvailability(offer.contract.end, offer.contract.start) // Ensure that contract is still valid today
                        && hasContractRemainingQuantity(offer.contract.frequency_quantity, offer.minimumOrderQuantity) // Ensure there is enough quantity for this contract
                    );
                }

                return offers
            }
        }
    },
    methods:{
        ...mapActions('sellerTabs', ['selectTabIndex']),
         
        goToManageOffers: function(event){
            if (event.target.localName !== 'th'){
                this.selectTabIndex(1)
                if(this.getPrices.length === 0) this.$store.dispatch("livePrices/editSettlementPrices");
                this.$router.push('/manageOffers/contract')
            } 
        }, 
       
    }
}
</script>